export enum Brand {
  BK = 'BK',
  PLK = 'PLK',
  TH = 'TH',
  FHS = 'FHS',
}
